import Vue from 'vue'
import App from './App.vue'
import { Tab, Tabs, List } from 'vant';
import VueJsonp from 'vue-jsonp';
import baseConfig from './commen/config';
import Util from './commen/Util';

Vue.use(VueJsonp);

Vue.use(Tab).use(Tabs).use(List);
Vue.config.productionTip = false
Vue.prototype.baseConfig = baseConfig;
Vue.prototype.Util = Util;

new Vue({
  render: h => h(App),
}).$mount('#app')
